import { createContext, useContext } from 'react';
export const MarketContext = createContext({ germany: false, path: '/' });
export const useMarket = () => useContext(MarketContext);
